module.exports = __webpack_public_path__ + "img/laser.634415b7.png";